import { Hero } from "@/components/Hero";
import { useSEO } from "@/hooks/useSEO";
import { lazy, Suspense, useState, useEffect } from "react";

const TrustBar = lazy(() =>
  import("@/components/TrustBar").then((m) => ({ default: m.TrustBar })),
);
const Services = lazy(() =>
  import("@/components/Services").then((m) => ({ default: m.Services })),
);
const Portfolio = lazy(() =>
  import("@/components/Portfolio").then((m) => ({ default: m.Portfolio })),
);
const Testimonials = lazy(() =>
  import("@/components/Testimonials").then((m) => ({
    default: m.Testimonials,
  })),
);
const LocationMap = lazy(() =>
  import("@/components/LocationMap").then((m) => ({ default: m.LocationMap })),
);
const CTA = lazy(() =>
  import("@/components/CTA").then((m) => ({ default: m.CTA })),
);

const DeferredSections = () => {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setLoad(true), 4500);
    const handleInteraction = () => setLoad(true);
    window.addEventListener("scroll", handleInteraction, {
      once: true,
      passive: true,
    });
    window.addEventListener("touchstart", handleInteraction, {
      once: true,
      passive: true,
    });
    window.addEventListener("mousemove", handleInteraction, {
      once: true,
      passive: true,
    });
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
      window.removeEventListener("mousemove", handleInteraction);
    };
  }, []);

  if (!load) return <div className="min-h-[200vh]" />;
  return (
    <Suspense fallback={<div className="min-h-[200vh]" />}>
      <TrustBar />
      <Services />
      <Portfolio />
      <Testimonials />
      <LocationMap />
      <CTA />
    </Suspense>
  );
};
const Index = () => {
  useSEO({
    title:
      "Pool Remodeling, Pavers & Deck Resurfacing in Broward County, FL | Precision Pavers & Pool Design",
    description:
      "Premium pool remodeling, deck resurfacing, driveway pavers, artificial turf, and outdoor enhancements across Fort Lauderdale, Coral Springs, Weston, and all of Broward County. Family-owned. Free estimates. Visit our Pompano Beach showroom.",
    canonicalUrl: "https://precisionpaverspools.com/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "HomeAndConstructionBusiness",
        name: "Precision Pavers & Pool Design",
        url: "https://precisionpaverspools.com/",
        telephone: "+1-954-200-3501",
        email: "precisionpaver@gmail.com",
        description:
          "Pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Broward County, FL.",
        address: {
          "@type": "PostalAddress",
          streetAddress: "605 SW 9th Terrace",
          addressLocality: "Pompano Beach",
          addressRegion: "FL",
          postalCode: "33069",
          addressCountry: "US",
        },
        areaServed: [
          { "@type": "City", name: "Fort Lauderdale" },
          { "@type": "City", name: "Coral Springs" },
          { "@type": "City", name: "Pembroke Pines" },
          { "@type": "City", name: "Weston" },
          { "@type": "City", name: "Miramar" },
          { "@type": "City", name: "Sunrise" },
          { "@type": "City", name: "Davie" },
          { "@type": "City", name: "Miami" },
          { "@type": "City", name: "Tampa" },
          { "@type": "City", name: "Orlando" },
        ],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Outdoor Living Services",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Pool Remodeling & Resurfacing",
              },
            },
            {
              "@type": "Offer",
              itemOffered: { "@type": "Service", name: "Pool Deck Remodeling" },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Driveway & Patio Pavers",
              },
            },
            {
              "@type": "Offer",
              itemOffered: { "@type": "Service", name: "Outdoor Enhancements" },
            },
          ],
        },
        sameAs: [
          "https://www.facebook.com/precisionpaverspools",
          "https://www.instagram.com/precisionpaverspools",
          "https://www.youtube.com/precisionpavers",
          "https://www.yelp.com/biz/precision-pavers-and-pool-design-pompano-beach",
          "https://www.tiktok.com/@precisionpavers",
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
        ],
      },
    ],
  });

  return (
    <>
      <Hero />
      <DeferredSections />
    </>
  );
};

export default Index;
